import React from 'react';
import { FormContext } from 'react-hook-form';
import { TextInput as RNTextInput } from 'react-native';
import { t, Trans } from '@lingui/macro';
import { useNavigation } from '@react-navigation/native';

import AuthenticationContainer from '@src/components/AuthenticationContainer';
import AuthenticationScrollView from '@src/components/AuthenticationScrollView';
import AuthenticationSendButton from '@src/components/AuthenticationSendButton';
// import RegionInput from '@src/components/RegionInput';
import KeyboardAvoidingView from '@src/components/KeyboardAvoidingView';
import Row from '@src/components/RTLRow';
import TextInput from '@src/components/TextInput';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import { i18n } from '@src/i18n';

import {
  BottomContainer,
  Container,
  InputContainer,
  RTLContainer,
  TextButton,
} from './styled';
import { Props, ScreenNavigationProp } from './types';
import useLoginForm from './useLoginForm';

const Screen: React.FC<Props> = () => {
  const { form, handleSubmit, loading } = useLoginForm();
  const passwordRef = React.useRef<RNTextInput>();
  const navigation = useNavigation<ScreenNavigationProp>();

  const handleSignInOTP = React.useCallback(() => {
    navigation.navigate('SignUpPhone');
  }, [navigation]);

  const handleForgotPassword = React.useCallback(() => {
    navigation.navigate('ForgetPassword');
  }, [navigation]);

  return (
    <>
      <VisibleStatusBar />
      <AuthenticationContainer>
        <AuthenticationScrollView>
          <KeyboardAvoidingView>
            <Container>
              <InputContainer>
                <FormContext {...form}>
                  <Container>
                    <Row>
                      {/* <RegionInput name="region" /> */}
                      <TextInput
                        disabled={loading}
                        name="identity"
                        label={i18n._(t`Phone or Username`)}
                        placeholder={i18n._(t`Enter your Phone or Username`)}
                        keyboardType="ascii-capable"
                        autoCompleteType="tel"
                        onSubmitEditing={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          passwordRef.current?.focus();
                        }}
                        returnKeyType="next"
                      />
                    </Row>
                    <TextInput
                      disabled={loading}
                      name="password"
                      label={i18n._(t`Password`)}
                      placeholder={i18n._(t`Enter your password`)}
                      returnKeyType="send"
                      secureTextEntry
                      // @ts-ignore
                      ref={passwordRef}
                      onSubmitEditing={handleSubmit}
                    />
                  </Container>
                  <RTLContainer>
                    <TextButton onPress={handleSignInOTP}>
                      <Trans>Sign In with OTP</Trans>
                    </TextButton>
                    <TextButton onPress={handleForgotPassword}>
                      <Trans>Forgot Password</Trans>
                    </TextButton>
                  </RTLContainer>
                </FormContext>
              </InputContainer>
              <BottomContainer>
                <AuthenticationSendButton
                  loading={loading}
                  disabled={loading}
                  onPress={handleSubmit}
                >
                  <Trans>Sign In</Trans>
                </AuthenticationSendButton>
              </BottomContainer>
            </Container>
          </KeyboardAvoidingView>
        </AuthenticationScrollView>
      </AuthenticationContainer>
    </>
  );
};

Screen.displayName = 'SignIn';

export default Screen;
